import startCase from 'lodash/startCase.js';

import Widget from '@/models/Widget.js';
import WidgetLayoutTemplate from '@/models/WidgetLayoutTemplate.js';

/**
 * Replace the user's widgets with a layout template's widgets. The server numbers the new widgets'
 * Mobile order too, so this resets both the grid and the phone order. The local widgets are replaced only
 * after the server applies the template, so a failed request leaves the dashboard as it was.
 *
 * @param {string} layoutName Template group name, e.g. "activities".
 * @returns {Promise<void>}
 */
export async function applyLayoutTemplate(layoutName) {
    const response = await Widget.api().post(
        '/api/widgets-template/layout',
        { layout: startCase(layoutName) },
        { save: false }
    );

    Widget.query().deleteAll();
    await response.save();
}

/**
 * "Reset layout" in Personalize: re-apply the first template in the layout chooser.
 *
 * @returns {Promise<boolean>} False when no template exists.
 */
export async function resetToDefaultLayout() {
    await WidgetLayoutTemplate.api().get('/api/widgets-template/layouts');

    const defaultTemplate = WidgetLayoutTemplate.query().orderBy('id').first();

    if (!defaultTemplate) return false;

    await applyLayoutTemplate(defaultTemplate.layout_name);

    return true;
}
